<template>
  <div class="nested-menu" ref="nestedMenu">
    <!-- 菜单头部（仅在子菜单层级显示返回按钮） -->
    <div v-if="level > 1" class="menu-back" @click="goBack">
      <i class="iconfont-ot-website">&#xe68f;</i>
      <span>返回</span>
    </div>

    <!-- 菜单项列表 -->
    <div class="menu-items" v-show="navigationStack.length === 0">
      <template v-for="(item, index) in menuData.children">
        <div v-if="item.show" :key="`menu-item-${generateItemKey(item, index)}`"   class="menu-item"
          :class="{ 'has-children': hasChildren(item) }">
          <a class="item-name multiline-1" v-if="item.url" :href="item.url" target="_blank"
            @click="$emit('menu-click')">
            {{ item.name }}
          </a>
          <router-link class="item-name multiline-1" :style="item.style" v-else :to="getRoutePath(item)"
            @click.native="$emit('menu-click')">
            {{ item.name }}
          </router-link>
          <div class="to-children" @click="handleItemClick(item, index)">
            <i v-if="hasChildren(item)" class="iconfont-ot-website arrow-icon">&#xe69f;</i>
          </div>
        </div>
      </template>

      <div class="featured-menu">
        <div class="title">{{ featured.BlockOnly[0].name }}</div>
        <div class="featured-menu-content">
          <template v-for="(item, index) in featured.BlockOnly[0].children">
            <div v-if="item.show" :key="`featured-item-${index}`">
              <div class="featured-item">
                <a :href="item.url" v-if="item.url">
                  <img :src="item.cover" :alt="item.name">
                  <div class="featured-item-content">
                    <span class="featured-item-title multiline-2">{{ item.name }}</span>
                  </div>
                </a>
                <router-link v-else :to="getRoutePath(item)" @click.native="$emit('menu-click')">
                  <img :src="item.cover" :alt="item.name">
                  <div class="featured-item-content">
                    <span class="featured-item-title multiline-2">{{ item.name }}</span>
                  </div>
                </router-link>
              </div>
            </div>
          </template>
        </div>

      </div>
      <div class="btns" v-if="!isLogin">
        <div class="button primary" @click="jumpTo('/user/login')">登录</div>
        <div class="button default" @click="jumpTo('/user/register')">注册会员</div>
      </div>
    </div>
    <!-- 展开所有子级菜单 -->
    <transition name="slide" mode="in-out">
      <div>
        <div class="menu-back" v-if="navigationStack.length > 0" @click="goBack">
          <i class="iconfont-ot-website">&#xe68f;</i>
          <span>返回</span>
        </div>
        <div v-if="navigationStack.length > 0" class="submenu-container" key="submenu">
          <!-- 第二层返回按钮 -->

          <div v-if="menuType === 'menu'">
            <div class="menu-sub-title">{{ currentItem.name }}</div>
            <ExpandedMenuItem v-for="(item, index) in getCurrentChildren()" :key="`expanded-item-${index}`" :item="item"
              :level="0" @navigate="onNavigate" />

            <div class="product-menu">
              <div class="title">
                <a :href="hotProduct.url" v-if="hotProduct.url">{{ hotProduct.name }}</a>
                <router-link class="multiline-1" v-else :to="getRoutePath(hotProduct)" @click.native="$emit('menu-click')">
                  <span class="name multiline-1">{{ hotProduct.name }}</span>
                </router-link>
                <i class="iconfont-ot-website arrow-icon">&#xe68f;</i>
              </div>
              <div class="lp-page-name-list">
                <template v-for="(lpItem, index) in hotProduct.children">
                  <div v-if="lpItem.show" :key="`lp-null-${index}`" class="lp-item" :class="`level-${level + 1}`">
                    <a v-if="lpItem.url" :href="lpItem.url" target="_blank" @click="$emit('menu-click')">
                      <img v-if="lpItem.cover" :src="lpItem.cover" :alt="lpItem.name" />
                      <span class="name multiline-2">{{ lpItem.name }}</span>
                    </a>
                    <router-link class="multiline-1" v-else :to="getRoutePath(lpItem)"
                      @click.native="$emit('menu-click')">
                      <img v-if="lpItem.cover" :src="lpItem.cover" :alt="lpItem.name" />
                      <span class="name multiline-2">{{ lpItem.name }}</span>
                    </router-link>
                  </div>
                </template>

              </div>
            </div>
          </div>
          <div v-else>
            <div class="brand-menu">
              <div class="title" :style="brandData.name=='品牌'?'color:#000000;':''">{{ brandData.name }}</div>
              <div class="brand-menu-content">
                <template v-for="(bItem, bIIndex) in brandData.children">
                  <div v-if="bItem.show" :key="bIIndex">
                    <a :href="bItem.url" v-if="bItem.url && bItem.show">
                      <img :src="bItem.cover" :alt="bItem.name">
                    </a>
                    <router-link v-else-if="bItem.show" :to="getRoutePath(bItem)" @click.native="$emit('menu-click')">
                      <img :src="bItem.cover" :alt="bItem.name">
                    </router-link>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ExpandedMenuItem from './ExpandedMenuItem.vue';

export default {
  name: 'NestedMenu',
  components: {
    ExpandedMenuItem
  },
  props: {
    menuData: {
      type: Object,
      required: true
    },
    featured: {},
    level: {
      type: Number,
      default: 1
    },
    isLogin: { type: Boolean, default: false }
  },
  data() {
    return {
      navigationStack: [], // 导航栈，记录访问过的菜单索引路径
      menuType: 'menu',
      brandData: {},
      hotProduct: {},
      currentItem: {},
    };
  },
  computed: {
    menuKey() {

      return `${this.level}-${this.generateMenuKey(this.menuData.children)}`;
    },
  },
  methods: {

    getRoutePath(item) {
      // 根据实际情况调整路由路径生成逻辑
      if (item.id) {
        return `/category/${item.id}`;
      }
      return '/';
    },
    jumpTo(path) {
      this.$router.push({ path: path });
    },
    generateItemKey(item, index) {
      return item.id ? item.id : `${index}-${item.name}`;
    },


    generateMenuKey(menuData) {

      if (!menuData || !menuData.length) return 'empty';
      return menuData.map((item, index) =>
        `${item.id || item.name}-${index}-${item.children ? this.generateMenuKey(item.children) : 'no-children'}`
      ).join('-');
    },

    hasChildren(item) {
      return item.children && item.children.length > 0;
    },

    handleItemClick(item, index) {
      this.currentItem = item
      if (this.hasChildren(item)) {
        if (item.show_type === 'LP_Page_null') {
          this.menuType = 'brand'
          this.brandData = item
        } else {
          this.menuType = 'menu'
          this.hotProduct = this.menuData.LP_Page_name
        }

        // 将当前索引入栈，表示进入子菜单展开模式
        this.navigationStack = [index]; // 只保留当前选中的索引
      } else {
        this.onNavigate(item);


      }
    },

    // 获取当前需要展开的所有子项
    getCurrentChildren() {
      if (this.navigationStack.length > 0) {
        const currentIndex = this.navigationStack[0];
        const selectedItem = this.menuData.children[currentIndex];
        return selectedItem.children || [];
      }
      return [];
    },

    // 处理子级菜单项点击
    handleChildClick(item) {
      if (!this.hasChildren(item)) {
        this.onNavigate(item);
      }
      // 有子项但不进入更深层级，保持展开状态
    },

    // 处理孙级菜单项点击
    handleGrandChildClick(item) {
      if (!this.hasChildren(item)) {
        this.onNavigate(item);
      }
    },

    // 处理曾孙级菜单项点击
    handleGreatGrandChildClick(item) {
      this.onNavigate(item);
    },

    goBack() {


      this.navigationStack = [];
      if (this.level > 1) {
        this.$emit('back');
      }
    },

    onNavigate(item) {
      this.$emit('navigate', item);
    },

    onBack() {
      this.navigationStack = [];
      if (this.level > 1) {
        this.$emit('back');
      }
    }
  },
  watch: {
    menuData: {
      handler() {
        // 当menuData变化时，清空导航栈
        this.navigationStack = [];
        this.$nextTick(() => {
          if (this.$refs.nestedMenu) {
            this.$refs.nestedMenu.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        });
      },
      deep: true
    }
  }
};
</script>
<style lang="scss">
.nested-menu {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  height: calc((100vh - 140px));
  overflow: auto;
  padding: 0 15px 80px;
  box-sizing: border-box;

  .featured-menu {
    padding: 33px 0 0px;
    box-sizing: border-box;

    .title {
      color: var(---, #212322);
      font-family: Matter;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      /* 150% */
      text-transform: uppercase;
      text-align: left;
      margin-bottom: 15px;
    }

    .featured-menu-content {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      row-gap: 20px;
      column-gap: 15px;

      .featured-item {
        display: flex;
        flex-direction: column;

        img {
          width: 100%;
          height: auto;
          object-fit: cover;
        }

        .featured-item-content {
          .featured-item-title {
            display: block;
            padding-top: 10px;
            color: var(---, #212322);
            font-family: Matter;
            font-size: 10px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-transform: capitalize;
            text-align: left;
          }
        }
      }
    }
  }


  .brand-menu {
    padding: 18px 0px;
    box-sizing: border-box;

    .title {
      color: #4B4F54;
      text-align: left;
      /* 中文正文/Text-Small-12-R */
      font-family: "Noto Sans CJK SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      /* 150% */
      text-transform: uppercase;
    }

    .brand-menu-content {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      /* 两列布局 */
      column-gap: 15px;
      row-gap: 15px;
      /* 间距20px */
      padding-top: 15px;

      div {
        img {
          width: 100%;
          height: auto;
          object-fit: cover;
          display: block;
        }
      }
    }
  }

  .product-menu {
    padding: 60px 0px;
    box-sizing: border-box;

    .title {
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      width: fit-content;

      a,
      span {
        color: inherit;
        text-align: left;
        color: var(---, #212322);
        font-family: "Noto Sans CJK SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        /* 150% */
        text-transform: uppercase;
        text-decoration: underline;
        text-underline-offset: 4px;
      }

      .arrow-icon {
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 2px;
      }
    }

    .lp-page-name-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      /* 两列布局 */
      // column-gap: 10px;
      // row-gap: 50px;
      /* 设置间距 */
      padding-top: 25px;

      .lp-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 0 5px 50px;
        /* 水平居中 */

        a,
        router-link {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          color: var(---, #212322);
          text-align: center;
          font-family: Matter;
          height: 100%;
          font-size: 13px;
          font-style: normal;
          font-weight: 700;

          img {
            width: 100%;
            // height: auto;
            // object-fit: cover;
            // margin-bottom: 8px;
            /* 图片和文字之间的间距 */
            width: 100%;
            aspect-ratio: 1 / 1;
            /* 明确指定1:1比例 */
            // object-fit: cover;
            display: block;
            max-width: 150px;
          }

          .name {
            text-align: center;
            /* 文字居中 */
            font-size: 14px;
            font-weight: 600;
            color: #212322;
            line-height: 1.4;
          }

          .multiline-2 {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }


  .menu-back {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    // border-bottom: 1px solid #eee;
    cursor: pointer;
    position: sticky;
    top: -0.5px;
    background: #fff;

    .iconfont-ot-website {
      margin-right: 10px;
      font-size: 14px;
      transform: rotate(-180deg);
      color: #212322;
      font-weight: 700;
    }

    span {
      font-size: 16px;
      font-weight: 700;
    }
  }

  .menu-items,
  .submenu-container {

    .menu-sub-title {
      color: #4B4F54;
      padding: 10px 0;

      /* 中文正文/Text-Small-12-R */
      font-family: "Noto Sans CJK SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      /* 150% */
      text-transform: uppercase;
      text-align: left;
    }

    .menu-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      box-sizing: border-box;

      &.has-children {
        // background-color: #fafafa;
      }

      .item-name {
        font-size: 14px;
        text-align: left;
        color: #212322;
        font-weight: 700;
        padding: 0px 20px 0px 0;
        margin: 15px 0;
        max-width: max-content;
        width: 100%;
      }

      .to-children {
        padding: 15px 0px;
        flex: 1;
        /* 不伸缩，宽度由内容决定 */
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-width: 20px;
        /* 确保有足够的空间显示箭头图标 */
      }

      .arrow-icon {
        font-size: 12px;
        color: #212322;
      }

      &:hover {
        background-color: #fff;
      }
    }
  }

  .submenu-container {
    // position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 10;
    // padding: 15px 15px;
    box-sizing: border-box;
    // box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  }

  // 滑入滑出动画
  .slide-enter-active {
    animation: slideInFromRight 0.2s ease-out;
  }

  .slide-leave-active {
    animation: slideOutToLeft 0.2s ease-in;
  }

  @keyframes slideInFromRight {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(0);
    }
  }

  @keyframes slideOutToLeft {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(-100%);
    }
  }

  .btns {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 60px 0 10px;
    box-sizing: border-box;
    gap: 15px;

    .button {
      padding: 14px 30px;
      border-radius: 100px;
      border: 1px solid var(---, #212322);
      cursor: pointer;
      font-size: 14px;
      width: 100%;
      box-sizing: border-box;

      &.normal {
        border: none;
        padding: 0;
        width: max-content;
      }

      &.default {

        // border: none;
        &:hover {
          background: #212322;
          color: #fff;
        }
      }

      &.primary {
        background: #212322;
        color: #fff;
        border: 1px solid var(---, #212322);

        &:hover {
          background: #fff;
          color: #212322;
        }
      }
    }
  }

  .multiline-1 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .multiline-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>